"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonSolUtilsConfig = void 0;
exports.CommonSolUtilsConfig = {
    defaultSolNetwork: {
        name: 'defaultSolNetwork',
        defaultValue: 'mainnet',
    },
};
//# sourceMappingURL=CommonSolUtilsConfig.js.map